export const CUSTOMER_VIEW_DURATION_MS = 12 * 60 * 60 * 1000;

export const isCustomerViewActive = (startedAtMs: number | null, nowMs: number): boolean =>
  startedAtMs !== null && nowMs - startedAtMs < CUSTOMER_VIEW_DURATION_MS;

export const customerViewExpiresInMs = (startedAtMs: number, nowMs: number): number =>
  startedAtMs + CUSTOMER_VIEW_DURATION_MS - nowMs;
